"use strict";

const importertrigger = document.querySelector("#importertrigger");
const importer = document.querySelector("#importer");

const setAttribute = element => attribute => value => {
  element.setAttribute(attribute, value);
};

const setActiveAttributeSearch = setAttribute(importer)("data-state");

const setSearch = e => {
  e.preventDefault();

  let state = importer.dataset.state
    ? setActiveAttributeSearch("")
    : setActiveAttributeSearch("active");
};

module.exports = {
  set: () => {
    if (importer) importertrigger.addEventListener("click", setSearch);
  }
};
